import { NOTIFICATION_BROADCAST_TYPE } from "@/entities/notification-broadcast";
import { useEventBusListener } from "@/modules/event-bus";

import { useJobModuleActionCompleted } from "./job-module-action-completed.hook";

const JobModuleActionCompleted = () => {
  const { runAction } = useJobModuleActionCompleted();

  useEventBusListener(
    NOTIFICATION_BROADCAST_TYPE.JOB_MODULE_COMPLETED,
    runAction
  );

  return <></>;
};

export default JobModuleActionCompleted;
